export enum ExperimentActionType {
  // Experiment management
  GET_EXPERIMENT = 'GET_EXPERIMENT',
  CREATE_EXPERIMENT = 'CREATE_EXPERIMENT',
  SET_EXPERIMENT = 'SET_EXPERIMENT',
  CLONE_EXPERIMENT = 'CLONE_EXPERIMENT',
  SET_CONFIGURATION = 'SET_CONFIGURATION',
  UPDATE_EXPERIMENT = 'UPDATE_EXPERIMENT',
  UPDATE_CONFIGURATION = 'UPDATE_CONFIGURATION',
  SET_ADAPTIVE_EXPERIMENT = 'SET_ADAPTIVE_EXPERIMENT',
  ADD_EXPERIMENT_VARIABLE = 'ADD_EXPERIMENT_VARIABLE',
  DELETE_EXPERIMENT_VARIABLE = 'DELETE_EXPERIMENT_VARIABLE',
  ADD_TREATMENT = 'ADD_TREATMENT',
  DELETE_TREATMENT = 'DELETE_TREATMENT',
  ADD_CONFIGURATION = 'ADD_CONFIGURATION',
  DELETE_CONFIGURATION = 'DELETE_CONFIGURATION',
  CLONE_CONFIGURATION = 'CLONE_CONFIGURATION',
  EDIT_TREATMENT = 'EDIT_TREATMENT',
  UPDATE_ASSIGNMENT_STRATEGY = 'UPDATE_ASSIGNMENT_STRATEGY',
  SPLIT_TREATMENTS_EVENLY = 'SPLIT_TREATMENTS_EVENLY',
  SET_VARIABLE_TECH_FAMILIES = 'SET_VARIABLE_TECH_FAMILIES',
  SET_VARIABLES = 'SET_VARIABLES',
  SET_ANALYSIS = 'SET_ANALYSIS',
  UPDATE_ANALYSIS_CONFIG = 'UPDATE_ANALYSIS_CONFIG',
  UPDATE_RESTRICT_BY_CONSTRAINT = 'UPDATE_RESTRICT_BY_CONSTRAINT',
  UPDATE_VALID_EXPERIMENT = 'UPDATE_VALID_EXPERIMENT',
  UPDATE_VALID_METRIC = 'UPDATE_VALID_METRIC',
  ADD_CONSTRAINT = 'ADD_CONSTRAINT',
  DELETE_CONSTRAINT = 'DELETE_CONSTRAINT',
  UPDATE_CONSTRAINT = 'UPDATE_CONSTRAINT',
  SET_CONSTRAINTS = 'SET_CONSTRAINTS',
  SET_SLOTTING_BY_GROUP = 'SET_SLOTTING_BY_GROUP',
}
